import PadraoModel from 'src/core/model/PadraoModel.js'

export default class MobiautoCorModel extends PadraoModel {
  recurso = 'mobiauto/cores';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Cores Mobiauto';

  colunasGrid = [
  ];

  form = {
    id: null,
    name: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
